import { normalizedTranslate } from '@rbilabs/components-library';
import styled, { css, keyframes } from 'styled-components';

import { LoyaltyBackground } from '../loyalty-background';

export const IncentiveDetailsWrapper = styled.div`
  width: 200vw;
  inset-inline-start: -100vw;
  position: relative;

  ${Styles.desktop} {
    width: unset;
    inset-inline-start: unset;
  }
`;

const slideIn = keyframes`
  from {
    transform: ${normalizedTranslate(0)};
  }
  to {
    transform: ${normalizedTranslate('100vw')};
  }
`;

export const IncentiveDetailsWithAnimation = styled.div`
  width: 100%;

  ${Styles.mobile} {
    animation: ${slideIn} 0.17s linear 1;
  }
`;

const IncentivesGridDefault = (incentiveSelected: boolean) => css`
  display: flex;
  width: 100vw;
  height: 100%;
  overflow: auto;

  ${IncentiveDetailsWithAnimation} {
    transform: ${normalizedTranslate(incentiveSelected ? '100vw' : '0')};
  }

  ${Styles.desktop} {
    width: unset;
    display: grid;
    grid-template-columns: 450px 1fr;

    ${IncentiveDetailsWithAnimation} {
      transform: unset;
    }
  }
`;

const IncentivesGridWidget = css`
  display: block;
`;

export const IncentivesGrid = styled(LoyaltyBackground)<{
  incentiveSelected: boolean;
  isWidget: boolean;
  isCarousel: boolean;
}>`
  ${p => (p.isWidget ? IncentivesGridWidget : IncentivesGridDefault(p.incentiveSelected))}
`;

export const IncentiveItemsContainer = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-block-start: 0;
`;

export const IncentiveList = styled.div<{
  isIncentiveSelected: boolean;
}>`
  padding: 0;
  margin: 0;
  transition: 0.25s;
  scroll-behavior: smooth;
  overflow-y: auto;
  width: 100vw;

  ${p => (p.isIncentiveSelected ? 'max-height: calc(100vh - env(safe-area-inset-bottom));' : 0)};

  ${Styles.desktop} {
    width: unset;
    max-height: unset;
  }

  #ptr-parent {
    overflow: visible !important;
  }
`;

export const IncentiveDetails = styled.div`
  border-inline-start: 1px solid ${Styles.color.grey.four};
`;

export const LoadingAnimationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 3rem;
`;
